import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import {
  createTaskTemplate,
  deleteTaskTemplate,
  listTaskTemplates,
  updateTaskTemplate,
  type TaskTemplateInput,
} from '../../services/tasks/taskTemplateService';

export const taskTemplatesKeys = {
  all: ['task-templates'] as const,
  list: (activeOnly: boolean) => ['task-templates', 'list', activeOnly] as const,
};

export function useTaskTemplates(activeOnly = false) {
  return useQuery({
    ...STATIC,
    queryKey: taskTemplatesKeys.list(activeOnly),
    queryFn: () => listTaskTemplates(activeOnly),
  });
}

export function useCreateTaskTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TaskTemplateInput) => createTaskTemplate(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: taskTemplatesKeys.all }),
  });
}

export function useUpdateTaskTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Partial<TaskTemplateInput> }) =>
      updateTaskTemplate(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: taskTemplatesKeys.all }),
  });
}

export function useDeleteTaskTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteTaskTemplate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: taskTemplatesKeys.all }),
  });
}
